import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(({ palette }) => ({
  header: {
    fontSize: "18px",
    fontWeight: 400,
    color: grey[500],
    whiteSpace: "nowrap",
  },
  chosenHeader: {
    fontSize: "18px",
    fontWeight: 500,
    color: palette.primary.main,
  },
  headerNumber: {
    width: 24,
    height: 24,
    borderRadius: "50%",
    backgroundColor: grey["400"],
    color: "white",
  },
  chosenHeaderNumber: {
    backgroundColor: palette.primary.main,
  },
  divider: {
    width: "100%",
    height: "1px",
    backgroundColor: grey[300],
  },
}));
